export default __webpack_public_path__ + "static/media/msg_illus.ff502f13.svg";